import { CHDataActionPayload, CHSuccessActionCollectionResult, CHSuccessActionResult, CHUuid } from "@app/root-store/actions";
import { CHDataAction, CHDataSuccessAction, DataErrorAction } from "../../../shared/resources/data-actions";

import { EventEmitter } from "@angular/core";
import { AuditLogInput } from "@app/audit-log/models/audit-log-type.model";
import { CHDevice } from "@app/project/model/ch-device";
import { CHService } from "@app/project/model/ch-service";
import { Action } from "@ngrx/store";
import { DataServiceError } from "../../../shared/services/data-service-error";

export enum ActionTypes {
    GetLiteServices = "[CH Service Management] GetLiteServices",
    GetLiteServicesSuccess = "[CH Service Management] GetLiteServicesSuccess",
    GetLiteServicesFailure = "[CH Service Management] GetLiteServicesFailure",
    ClearLiteServiceState = "[CH Service Management] ClearLiteServiceState",

    GetServicesSuccess = "[CH Service Management] GetServicesSuccess",
    GetServicesFailure = "[CH Service Management] GetServicesFailure",

    GetServiceToDeviceMap = "[CH Service Management] GetServiceToDeviceMap",
    GetServiceToDeviceMapFailure = "[CH Service Management] GetServiceToDeviceMapFailure",

    ClearServiceState = "[CH Service Management] ClearServiceState",

    UpdateServiceNameAndZone = "[CH Service Management] UpdateServiceNameAndZone",
    UpdateServiceNameAndZoneSuccess = "[CH Service Management] UpdateServiceNameAndZoneSuccess",
    UpdateServiceNameAndZoneFailure = "[CH Service Management] UpdateServiceNameAndZoneFailure",

    RemovePendingServiceMapDeletion = "[CH Service Management] RemovePendingServiceMapDeletion",
    DeleteServiceMap = "[CH Service Management] DeleteServiceMap",
    DeleteService = "[CH Service Management] DeleteService",
    DeleteServiceSuccess = "[CH Service Management] DeleteServiceSuccess",
    DeleteServiceFailure = "[CH Service Management] DeleteServiceFailure",
    DeleteServiceConfirmation = "[CH Service Management] DeleteServiceConfirmation",
    DeleteServiceConfirmationDismiss = "[CH Service Management] DeleteServiceConfirmationDismiss",
}

export type ServiceAction = CHDataAction<CHService>;
export type LiteServiceAction = ServiceAction;
type ServiceSuccessAction = CHDataSuccessAction<CHService>;
type ServiceFailureAction = DataErrorAction<CHService | CHSuccessActionResult<CHService>>;
type LiteServiceSuccessAction = ServiceSuccessAction;
type LiteServiceFailureAction = ServiceFailureAction;
type ServicePayload = CHDataActionPayload;
type ServiceResultPayload = CHSuccessActionCollectionResult<CHService>;
type ServiceError = DataServiceError<CHUuid & { result: CHService }>;

export class GetLiteServices implements LiteServiceAction {
    readonly type = ActionTypes.GetLiteServices;
    constructor(public readonly payload: ServicePayload) {}
}

export class GetLiteServicesSuccess implements LiteServiceSuccessAction {
    readonly type = ActionTypes.GetLiteServicesSuccess;
    constructor(public readonly result: ServiceResultPayload) {}
}

export class GetLiteServicesFailure implements LiteServiceFailureAction {
    readonly type = ActionTypes.GetLiteServicesFailure;
    constructor(public readonly error: ServiceError) {}
}

export class GetServicesSuccess implements ServiceSuccessAction {
    readonly type = ActionTypes.GetServicesSuccess;
    constructor(public readonly result: ServiceResultPayload) {}
}

export class GetServiceToDeviceMap implements ServiceAction {
    readonly type = ActionTypes.GetServiceToDeviceMap;
    constructor(public readonly payload: ServicePayload) {}
}

export class GetServiceToDeviceMapFailure implements ServiceFailureAction {
    readonly type = ActionTypes.GetServiceToDeviceMapFailure;
    constructor(public readonly error: ServiceError) {}
}

export class ClearServiceState implements Action {
    readonly type = ActionTypes.ClearServiceState;
}

export class ClearLiteServiceState implements Action {
    readonly type = ActionTypes.ClearLiteServiceState;
}

export class UpdateServiceNameAndZone implements ServiceAction {
    readonly type = ActionTypes.UpdateServiceNameAndZone;

    constructor(
        public readonly payload: {
            uuid: string;
            instanceId: string;
            name: string;
            zoneUids?: string[];
            callbackEmitter?: EventEmitter<any>;
            logAction?: any;
        }
    ) {}
}

export class UpdateServiceNameAndZoneSuccess implements ServiceAction {
    readonly type = ActionTypes.UpdateServiceNameAndZoneSuccess;

    constructor(
        public readonly payload: {
            uuid: string;
            instanceId: string;
            name: string;
            zoneUids: string[];
        }
    ) {}
}

export class UpdateServiceNameAndZoneFailure implements ServiceFailureAction {
    readonly type = ActionTypes.UpdateServiceNameAndZoneFailure;
    constructor(public readonly error: ServiceError) {}
}

export class RemovePendingServiceMapDeletion implements Action {
    readonly type = ActionTypes.RemovePendingServiceMapDeletion;
    constructor(public readonly payload: CHDataActionPayload) {}
}

export class DeleteServiceMap implements ServiceAction {
    readonly type = ActionTypes.DeleteServiceMap;
    constructor(
        public readonly payload: {
            uuid: string;
            service: CHService;
            device: CHDevice;
            deviceName?: string;
            callbackEmitter?: EventEmitter<any>;
            logAction?: AuditLogInput;
        }
    ) {}
}

export class DeleteService implements ServiceAction {
    readonly type = ActionTypes.DeleteService;
    constructor(public readonly payload: ServicePayload) {}
}

export class DeleteServiceSuccess implements ServiceSuccessAction {
    readonly type = ActionTypes.DeleteServiceSuccess;
    constructor(public readonly result: CHSuccessActionResult<CHService>) {}
}

export class DeleteServiceFailure implements ServiceFailureAction {
    readonly type = ActionTypes.DeleteServiceFailure;
    constructor(public readonly error: ServiceError) {}
}

export class DeleteServiceConfirmation implements ServiceAction {
    readonly type = ActionTypes.DeleteServiceConfirmation;
    constructor(public readonly payload: ServicePayload) {}
}

export class DeleteServiceConfirmationDismiss implements Action {
    readonly type = ActionTypes.DeleteServiceConfirmationDismiss;
    constructor(public readonly payload: ServicePayload) {}
}

export type Actions =
    | GetServicesSuccess
    | GetServiceToDeviceMap
    | GetServiceToDeviceMapFailure
    | ClearServiceState
    | UpdateServiceNameAndZone
    | UpdateServiceNameAndZoneSuccess
    | UpdateServiceNameAndZoneFailure
    | RemovePendingServiceMapDeletion
    | DeleteServiceMap
    | DeleteService
    | DeleteServiceSuccess
    | DeleteServiceFailure
    | DeleteServiceConfirmation
    | DeleteServiceConfirmationDismiss;

export type LiteActions = GetLiteServices | GetLiteServicesSuccess | GetLiteServicesFailure | ClearLiteServiceState;
